import {Card as CardAnt} from 'antd';
import React, {FC} from 'react';

import './card.less';

interface ICardProps {
    className: string;
}

export const Card: FC<ICardProps> = ({className, ...restProps}: ICardProps) => (
    <CardAnt
        {...restProps}
        className={`card-widget ${className}`}
    />
);
